import React from 'react';
import { black } from 'web-ui-kit/colors';
var STYLE_VARIANTS = {
  'medium': {
    width: '1rem'
  },
  'small': {
    width: '.75rem'
  }
};

function ChevronDown(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? black : _ref$color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant;
  var calculatedWidth = variant ? STYLE_VARIANTS[variant]['width'] : STYLE_VARIANTS.small.width;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      onClick: onClick,
      style: {
        cursor: 'pointer'
      },
      width: calculatedWidth,
      "data-testid": "chevron-down",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "button"
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: className,
      d: "M7.53366 11.8727L2.19318 6.69533C1.93561 6.44563 1.93561 6.0408 2.19318 5.79113L2.81606 5.18727C3.07318 4.93799 3.48991 4.93752 3.74765 5.1862L8.00001 9.28939L12.2524 5.1862C12.5101 4.93752 12.9268 4.93799 13.1839 5.18727L13.8068 5.79113C14.0644 6.04083 14.0644 6.44566 13.8068 6.69533L8.46637 11.8727C8.2088 12.1224 7.79122 12.1224 7.53366 11.8727Z",
      fill: color
    }))
  );
}

export default ChevronDown;